document.addEventListener('DOMContentLoaded', () => {
    const navList = document.querySelector('.tabs-advanced__nav ul');
    const contentContainer = document.querySelector('.tabs-advanced__content');
    if (!navList || !contentContainer) return;

    const navItems = [...navList.children];
    const tabs = [...contentContainer.querySelectorAll('.tabs-advanced__tab')];
    if (navItems.length !== tabs.length) console.error('Tabs/nav count mismatch');

    const mql = window.matchMedia('(max-width: 791px)');
    let isMobile = mql.matches;

    const activate = idx => {
        navItems.forEach((li, i) => li.classList.toggle('active', i === idx));
        tabs.forEach((tab, i) => tab.classList.toggle('active', i === idx));
    };

    const equalizeHeights = () => {
        let max = 0;
        tabs.forEach(tab => {
            const { position, visibility, display } = tab.style;
            tab.style.position = 'absolute';
            tab.style.visibility = 'hidden';
            tab.style.display = 'block';
            max = Math.max(max, tab.scrollHeight);
            tab.style.position = position;
            tab.style.visibility = visibility;
            tab.style.display = display;
        });
        tabs.forEach(tab => tab.style.height = `${max}px`);
    };

    const setup = () => {
        if (isMobile) {
            contentContainer.hidden = true;
            tabs.forEach((tab, i) => {
                const li = navItems[i];
                if (li && !li.contains(tab)) li.append(tab);
                tab.style.height = '';
            });
        } else {
            contentContainer.hidden = false;
            tabs.forEach(tab => {
                if (tab.parentElement !== contentContainer) contentContainer.append(tab);
            });
            equalizeHeights();
        }
        const activeIdx = navItems.findIndex(li => li.classList.contains('active'));
        activate(activeIdx > -1 ? activeIdx : 0);
    };

    navItems.forEach((li, i) => {
        li.querySelector('strong')?.addEventListener('click', () => activate(i));
    });

    mql.addEventListener('change', ({ matches }) => {
        isMobile = matches;
        setup();
    });

    setup();
});
